<template>
  <div
    class="t-fast-buy"
    :class="type"
    @click="
      toggleRightMenu();
      toggleFastbuy();
    "
  >
    <svg
      width="18"
      height="24"
      viewBox="0 0 18 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.625 0C6.235 7.189 0 9.664 0 15.996C0 20.297 3.069 23.968 9 24C14.931 24.032 18 19.586 18 15.044C18 10.903 15.938 6.998 12.048 4.57C12.972 7.177 11.742 9.558 10.547 10.378C10.617 7.041 9.422 2.089 5.625 0ZM10.336 13C14.091 16.989 11.785 22 8.769 22C6.934 22 5.99 20.735 6 19.423C6.019 16.99 8.737 16.988 10.336 13Z"
      />
    </svg>
    <span>Быстрый заказ</span>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {},
  methods: {
    ...mapMutations('params', ['toggleRightMenu', 'toggleFastbuy']),
  },
};
</script>
<style lang="sass" scoped>
.t-fast-buy
  display: flex
  align-items: center
  font-size: 16px
  line-height: 18px
  font-weight: 500
  margin-right: 32px
  cursor: pointer
  transition: all .3s

  svg
    margin-right: 16px
    transition: all .3s

  &.main-page,
  &.left-menu
    color: #FFFFFF
    border: 1px solid #FFFFFF
    border-radius: 50px
    padding: 0 24px
    margin: 0 32px 0 0
    span
      line-height: 46px
    svg
      fill: #FFFFFF

  &.products
    svg
      fill: #5599DD

  &:hover
    &.main-page
      border: 1px solid #5599DD
      background-color: #5599DD
    &.products
      color: #5599DD
  &:active
    transform: scale3d(.98,.98,.98)
    transition: all .2s

  @media screen and ( max-width: 1919px )
    justify-content: center
    border: 1px solid #5599DD
    border-radius: 50%
    margin-right: 16px

    &.products
      width: 48px
      height: 48px
      span
        display: none
      svg
        padding: 0
        margin-right: 0

    &:hover
      &.main-page
        border: 1px solid #5599DD
      &.products
        background-color: #5599DD
        svg
          fill: #ffffff

  @media screen and ( max-width: 1279px )
    &.main-page,
    &.products,
    &.left-menu
      margin-right: 0
      padding: 0
      width: 40px
      height: 40px
      svg
        padding: 0
        margin-right: 0
      span
        display: none

    &:hover
      &.main-page,
      &.products
        background-color: #5599DD
        svg
          fill: #ffffff
      &.left-menu
        background-color: #ffffff
        border: 1px solid #ffffff
        svg
          fill: #5599DD
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/fastBuy.vue